import { GroupTravelStaticAlerts } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/GroupTravelStaticAlerts";
import { LastVisitedStation } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/LastVisitedStation";
import { TrainDetailsButton } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/TrainDetailsButton";
import { TrainEventBadges } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/TrainEventBadges";
import { AltTransIncidentTrain } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";
import { CallButton } from "shared/components/buttons/CallButton";
import { HStack, Text } from "shared/components/Spor";

type ExpandableBodyProps = {
  actionableTrain: AltTransIncidentTrain;
};

export const ExpandableBodyContent: FC<ExpandableBodyProps> = ({
  actionableTrain,
}) => (
  <>
    <div>
      <Text variant="sm" fontWeight="bold">
        Sist passert
      </Text>
      <LastVisitedStation trainRoute={actionableTrain.trainRoute} />
    </div>

    <div>
      <Text variant="sm" fontWeight="bold" mb="1">
        Toghendelser
      </Text>
      <TrainEventBadges events={actionableTrain.events} />
    </div>

    <div>
      <Text variant="sm" fontWeight="bold">
        Kontakt
      </Text>
      <HStack gap="1" mt="1">
        {actionableTrain.trainStaffOnDuty.map((staffOnDuty) => (
          <CallButton
            key={staffOnDuty.functionalTelephoneNumber}
            label={staffOnDuty.function}
            phoneNumber={staffOnDuty.functionalTelephoneNumber}
            size="xs"
          />
        ))}
      </HStack>
    </div>

    <div>{/* This box intentionally left blank :) */}</div>
    <div style={{ gridColumn: "1 / -1" }}>
      <GroupTravelStaticAlerts
        events={actionableTrain.events}
        trainId={actionableTrain.id}
      />
    </div>

    <div
      style={{
        gridColumn: "1 / -1",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <TrainDetailsButton altTransPlanningTrainId={actionableTrain.id} />
    </div>
  </>
);
